import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SITE_URL = 'https://www.vivamore.com.my';
export const SITE_NAME = 'Vivamore Dining';
export const DEFAULT_IMAGE = `${SITE_URL}/hero-wedding.jpg`;

const DEFAULT_DESC =
  'Vivamore Dining is a Western-Asian comfort food destination on an elegant rooftop at Level 6, NU Sentral Mall, Kuala Lumpur. Perfect for events, celebrations & private walk-in dining.';

// Restaurant / LocalBusiness structured data
const restaurantSchema = {
  '@context': 'https://schema.org',
  '@type': 'Restaurant',
  name: 'Vivamore Dining',
  image: DEFAULT_IMAGE,
  url: SITE_URL,
  telephone: '+60196547318',
  servesCuisine: ['Western', 'Asian', 'Comfort Food', 'Malaysian'],
  priceRange: 'RM',
  description: DEFAULT_DESC,
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Level 6, NU Sentral Mall',
    addressLocality: 'Kuala Lumpur',
    addressRegion: 'Kuala Lumpur',
    addressCountry: 'MY'
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '11:00',
      closes: '22:00'
    }
  ],
  acceptsReservations: 'True',
  sameAs: []
};

export default function Seo({
  title,
  description = DEFAULT_DESC,
  keywords,
  path = '/',
  image = DEFAULT_IMAGE,
  type = 'website',
  schema
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Elegant Rooftop Dining & Events at NU Sentral, KL`;
  const canonical = `${SITE_URL}${path === '/' ? '' : path}`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonical} />
      <meta name="robots" content="index, follow" />

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_MY" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Structured data */}
      <script type="application/ld+json">{JSON.stringify(schema || restaurantSchema)}</script>
    </Helmet>
  );
}
